import { createStandaloneToast } from '@chakra-ui/react';

const { toast } = createStandaloneToast();

export class ToastUtil {
  static success(title, description = '') {
    toast({
      title,
      description,
      status: 'success',
      duration: 3000,
      isClosable: true,
      position: 'top',
    });
  }

  static error(title, description = '') {
    toast({
      title,
      description,
      status: 'error',
      duration: 3000,
      isClosable: true,
      position: 'top',
    });
  }

  static handleApiResponse(response, successTitle = 'Success', errorTitle = 'Error') {
    if (response?.success) {
      this.success(successTitle, response.message);
    } else {
      this.error(errorTitle, response?.message || 'An error occurred');
    }
  }
}
